// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bold-text[data-v-4836b5ef]{font-weight:bold;color:var(--stan-primary-primary-color)}", "",{"version":3,"sources":["webpack://src/components/modals/ManageMembershipModal.vue"],"names":[],"mappings":"AAAA,4BAA4B,gBAAgB,CAAC,uCAAuC","sourcesContent":[".bold-text[data-v-4836b5ef]{font-weight:bold;color:var(--stan-primary-primary-color)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
